import React, { useContext, useState } from "react"
import IcoMoon, {IconList} from "react-icomoon"
import iconSet from "../assets/fonts/icomoon/selection.json"


const Icon = (props) => <IcoMoon iconSet={iconSet} {...props} />

export default Icon
